import React from "react";
import { Badge } from "@mantine/core";

const STATUS_COLORS = {
  DFT: "yellow",
  ACTIVE: "green",
  INACTIVE: "gray",
  PENDING: "yellow",
  IN_PROGRESS: "blue",
  APPROVED: "green",
  REJECTED: "red",
  CANCELLED: "gray",
  TERMINATED: "dark",
  EXPIRED: "orange",
};

const McaStatusBadge = ({ status }) => (
  <Badge
    size="xs"
    radius={0}
    color={STATUS_COLORS[status] ?? "gray"}
    variant="filled"
  >
    {status?.replace(/_/g, " ") ?? "--"}
  </Badge>
);

export default McaStatusBadge;
